<div class="At-SectionCreateChannel">
  <button class="At-BackBtn" routerLink="/dashboard/subscription"><i class="icon-back-arrow"></i>Back</button>
  <div class="At-CreateChannelContent">
    <div class="At-Titel">
      <h2>Create A New Channel</h2>
    </div>
    <div class="At-CreateChanneltabs">
      <tabset>
        <tab heading="Information" id="tab1">
          <form class="At-CreateChannel-Form">
            <fieldset>
              <div class="At-CreateChannelbox">
                <div class="form-group floating-label-group">
                  <input type="text" class="form-control" placeholder="" required>
                  <label class="floating-label">Title</label>
                </div>
                <div class="form-group floating-label-group">
                  <input type="text" class="form-control" placeholder="" required>
                  <label class="floating-label">Description</label>
                </div>
              </div>
              <div class="form-group">
                <a href="javascript:void(0);" routerLink="/dashboard/channels" class="At-Btn">next</a>
              </div>
            </fieldset>
          </form>
        </tab>
        <tab heading="Add Members">
          <form class="At-CreateChannel-Form">
            <fieldset>
              <div class="At-AddMembersBox">
                <div class="At-Tagsarea">
                  <div class="At-Tagbox">
                    <figure class="At-Tagimge">
                      <img src="assets/images/tags/tag-img01.png" alt="TagImage">
                    </figure>
                    <h4>Julian...</h4>
                    <button type="button" class="At-CrossBtn"><i class="icon-cancel"></i></button>
                  </div>
                  <div class="At-Tagbox">
                    <figure class="At-Tagimge">
                      <img src="assets/images/tags/tag-img02.png" alt="TagImage">
                    </figure>
                    <h4>Jacob...</h4>
                    <button type="button" class="At-CrossBtn"><i class="icon-cancel"></i></button>
                  </div>
                  <div class="At-Tagbox">
                    <figure class="At-Tagimge">
                      <img src="assets/images/tags/tag-img03.png" alt="TagImage">
                    </figure>
                    <h4>Softpe...</h4>
                    <button type="button" class="At-CrossBtn"><i class="icon-cancel"></i></button>
                  </div>
                </div>
                <div class="At-MemberListBox">
                  <ul class="At-CustomScroll">
                    <li>
                      <div class="At-InfoBox">
                        <label class="At-checkBoxLabel">
                          <input type="checkbox" checked="checked">
                          <span class="checkmark"></span>
                        </label>
                        <div class="At-InfoImg">
                          <figure>
                            <img src="assets/images/members/member-img01.png" alt="">
                            <div class="At-badgePurple">
                              <i class="icon-bage"></i>
                            </div>
                          </figure>
                        </div>
                        <div class="At-InfoTitle d-flex">
                          <div class="At-TitleLeft">
                            <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span></h5>
                            <h6>Last Seen 12:09am</h6>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="At-InfoBox">
                        <label class="At-checkBoxLabel">
                          <input type="checkbox" checked="checked">
                          <span class="checkmark"></span>
                        </label>
                        <div class="At-InfoImg">
                          <figure>
                            <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
                          </figure>
                        </div>
                        <div class="At-InfoTitle d-flex">
                          <div class="At-TitleLeft">
                            <h5>Micheal Decosta . <span>mikkie</span></h5>
                            <h6>Last Seen 3 hrs ago</h6>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="At-InfoBox">
                        <label class="At-checkBoxLabel">
                          <input type="checkbox" checked="checked">
                          <span class="checkmark"></span>
                        </label>
                        <div class="At-InfoImg">
                          <figure>
                            <img src="assets/images/members/member-img03.png" alt="">
                          </figure>
                        </div>
                        <div class="At-InfoTitle d-flex">
                          <div class="At-TitleLeft">
                            <h5>Jacob_98 . <span>jazzy</span></h5>
                            <h6>Last Seen yesterday</h6>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="At-InfoBox">
                        <label class="At-checkBoxLabel">
                          <input type="checkbox" checked="checked">
                          <span class="checkmark"></span>
                        </label>
                        <div class="At-InfoImg">
                          <figure>
                            <img src="assets/images/members/member-img04.png" alt="">
                          </figure>
                        </div>
                        <div class="At-InfoTitle d-flex">
                          <div class="At-TitleLeft">
                            <h5>Softpetal:) . <span>floralqueen</span></h5>
                            <h6>Last Seen yesterday</h6>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="At-InfoBox">
                        <label class="At-checkBoxLabel">
                          <input type="checkbox" checked="checked">
                          <span class="checkmark"></span>
                        </label>
                        <div class="At-InfoImg">
                          <figure>
                            <img src="assets/images/members/member-img05.png" alt="">
                            <div class="At-badgePurple">
                              <i class="icon-bage"></i>
                            </div>
                          </figure>
                        </div>
                        <div class="At-InfoTitle d-flex">
                          <div class="At-TitleLeft">
                            <h5>Anatoli . <span class="At-TextBlue">matt </span> . <span class="At-TextBlue">Project Manager</span></h5>
                            <h6>Last Seen 19th Aug, 2020</h6>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="At-InfoBox">
                        <label class="At-checkBoxLabel">
                          <input type="checkbox" checked="checked">
                          <span class="checkmark"></span>
                        </label>
                        <div class="At-InfoImg">
                          <figure>
                            <img src="assets/images/members/member-img06.png" alt="">
                          </figure>
                        </div>
                        <div class="At-InfoTitle d-flex">
                          <div class="At-TitleLeft">
                            <h5>Micheal Decosta . <span>mikkie</span></h5>
                            <h6>Last Seen 3 hrs ago</h6>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="At-InfoBox">
                        <label class="At-checkBoxLabel">
                          <input type="checkbox" checked="checked">
                          <span class="checkmark"></span>
                        </label>
                        <div class="At-InfoImg">
                          <figure>
                            <img src="assets/images/members/member-img07.png" alt="">
                          </figure>
                        </div>
                        <div class="At-InfoTitle d-flex">
                          <div class="At-TitleLeft">
                            <h5>Jacob_98 . <span>jazzy</span></h5>
                            <h6>Last Seen yesterday</h6>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="form-group">
                <button class="At-Btn" routerLink="/dashboard/channels">done</button>
              </div>
            </fieldset>
          </form>
        </tab>
      </tabset>
  </div>
</div>
